import styles from "./table.module.css"
import { NavLink, useParams } from "react-router-dom"
import { useCallback, useEffect, useState, useRef, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
// import { getTable } from "../../../utils/api-tables"
import Preloader from "../../preloader/preloader"
import { setIsLoading } from "../../../services/reducers/preloader-slice"
import TablePrompt from "../tablePrompt/tablePrompt"
import greenArrow from "../../../images/arrow-green-table.svg"
import redArrow from "../../../images/arrow-red-table.svg"
import cursorPrompt from "../../../images/table-prompt-cursor-hover.svg"

// import { setTables } from "../../../services/reducers/tables-slice"
import { useActiveButton } from "../../../services/context/ActiveButtonContext"

function Table() {
  const params = useParams()
  const valueContext = useActiveButton()

  const table = useSelector((store) => store.tables.tables)
  // console.log(table);
  const isLoading = useSelector((store) => store.preloader.isLoading)
  // const tableName = useSelector((store) => store.tables.tableName)
  // const subscription = useSelector((store) => store.tables.subForFetch)
  const dispatch = useDispatch()
  // console.log(table);
  const [promptToggle, setPromptToggle] = useState(
    localStorage.getItem("tablePromptToggle")
  )
  useMemo(() => {
    dispatch(setIsLoading(true))
    valueContext.getTableFromApi(params.sub, params.slug)
  }, [params.slug])

  // Функция для сортировки ключей
  function sortKeys(keys) {
    const priorityKeys = ["Название", "Компания", "название", "компания"]
    return keys.sort((a, b) => {
      if (priorityKeys.includes(a)) return -1
      if (priorityKeys.includes(b)) return 1
      return 0
    })
  }

  const txtColor = (key, text, i) => {
    if (text[0] === "+" || (key === "Лонг / Шорт" && text === "Лонг")) {
      return styles.nameTextGreen
    } else if (text[0] === "-" || (key === "Лонг / Шорт" && text === "Шорт")) {
      return styles.nameTextRed
    } else if (i === 0) {
      return styles.nameTextFirst
    }

    return styles.nameText
  }

  const headlineStyles = (keyName, i) => {
    if (i === 0) {
      return styles.titleName
    }
    return styles.title
  }

  // const formattedTextTitle3 = (el) => {
  //   function splitStringBySpace(str) {
  //     let mid
  //     if (str.length === 13) {
  //       mid = Math.ceil(str.length / 2) + 7
  //     } else {
  //       mid = Math.ceil(str.length / 2) + 1
  //     }
  //     // const mid = Math.ceil(str.length / 2) + 4;

  //     const spaceIndex = str.lastIndexOf(" ", mid)
  //     if (spaceIndex === -1) {
  //       return [str.trim().substring(0, mid), str.substring(mid)]
  //     } else {
  //       return [
  //         str.trim().substring(0, spaceIndex),
  //         str.substring(spaceIndex + 1),
  //       ]
  //     }
  //   }
  //   const [firstPart, secondPart] = splitStringBySpace(el)
  //   const textWithBreak = `${firstPart} <br> ${secondPart}`

  //   if (el.trim().includes(" ")) {
  //     return (
  //       <div
  //         style={{ "vertical-align": "top", "text-align": "end" }}
  //         dangerouslySetInnerHTML={{ __html: textWithBreak }}
  //       />
  //     )
  //   } else if (!el.trim().includes(" ")) {
  //     return el
  //   }
  // }

  const formattedTextTitle = (el) => {
    if (el === "") {
      return "-"
    }
    return (
      <div
        style={{ "text-align": "center" }}
        className={styles.textColumn}
        dangerouslySetInnerHTML={{ __html: el }}
      />
    )
  }

  const leftLineStyle = (keyName, i, index, element) => {
    if (
      (!element["Количество выплат в год"] &&
        element["Количество выплат в год"] === "") ||
      element["Количество выплат в год"] < 1
    ) {
      return styles.columnRed
    }

    if (i === 0) {
      if (index % 2 === 1) {
        return styles.leftColumnLineGray
      }
      if (index % 2 === 0) {
        return styles.leftColumnLine
      }
    }
    return styles.allColumn
  }

  const scrollTable = (direction) => {
    const container = document.getElementById("containerTable")
    const content = document.getElementById("container")
    const leftButton = document.getElementById("leftButton")
    const rightButton = document.getElementById("rightButton")

    container.addEventListener("scroll", function () {
      // Получаем ширину видимой области блока 1310
      const visibleWidth = container.clientWidth
      // Получаем ширину содержимого блока 1656
      const contentWidth = content.offsetWidth
      // Получаем значение упора скролла для правой части блока
      const scrollTop = contentWidth > visibleWidth ? container.scrollLeft : 0
      if (container.scrollLeft + 10 >= contentWidth - visibleWidth) {
        rightButton.className = styles.rightButtonNoActive
      }
      if (container.scrollLeft + 10 < contentWidth - visibleWidth) {
        rightButton.className = styles.rightButton
      }
      if (container.scrollLeft === 0) {
        leftButton.className = styles.leftButtonNoActive
      }
      if (container.scrollLeft > 0) {
        leftButton.className = styles.leftButton
      }
    })

    const scrollAmount = 300 // Значение прокрутки
    const scrollStep = 5 // Шаг прокрутки
    let scrollCount = 0
    const scrollInterval = setInterval(function () {
      if (scrollCount >= scrollAmount) {
        clearInterval(scrollInterval)
      } else {
        direction === "right" && (container.scrollLeft += scrollStep)
        direction === "left" && (container.scrollLeft -= scrollStep)
        scrollCount += scrollStep
      }
    }, 1)
  }

  const arrow = (keyName, i, el) => {
    if (
      i === 0 &&
      !!el["Текущая цена"] &&
      !!el["Точка входа"] &&
      el["Текущая цена"] >= el["Точка входа"]
    ) {
      return <img src={greenArrow} className={styles.arrowTitle} />
    }
    if (
      i === 0 &&
      !!el["Текущая цена"] &&
      !!el["Точка входа"] &&
      el["Текущая цена"] < el["Точка входа"]
    ) {
      return <img src={redArrow} className={styles.arrowTitle} />
    }
    return null
  }

  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 })
  const [promptVisible, setPromptVisible] = useState("0")

  const handleMouseMove = (keyName, i, index, element) => {
    // return styles.columnRed

    document.addEventListener("mousemove", function (event) {
      let x = event.pageX // Координата X курсора относительно левого верхнего угла окна браузера
      let y = event.pageY // Координата Y курсора относительно левого верхнего угла окна браузера
      setCursorPosition({ x, y })
    })

    if (
      i === 0 &&
      element["Количество выплат в год"] !== undefined &&
      !element["Количество выплат в год"]
    ) {
      setTimeout(() => {
        setPromptVisible("1")
      }, 1000)
    }
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setPromptVisible("0")
    }, 2000) // 1000 миллисекунд = 1 секунда

    // Очистить таймер при размонтировании компонента или при следующем вызове эффекта
    return () => clearTimeout(timeoutId)
  }, [promptVisible])

  const ref = useRef(null)
  const myElementRef = useRef(null)
  // const styleColumn = (keyName, i, index, element) => {
  //   if (!element["Количество выплат в год"]) {
  //     if (
  //       element["Количество выплат в год"] === "" ||
  //       element["Количество выплат в год"] < 1
  //     ) {
  //       return styles.columnRed
  //     }
  //   }
  // }

  const formattedTextColumn = (el) => {
    return (
      <div
        // style={{ "vertical-align": "top", "text-align": "start" }}
        className={styles.textColumn}
        dangerouslySetInnerHTML={{ __html: el }}
      />
    )
  }

  const formattedText = (el) => {
    if (el === "") {
      return "-"
    }
    const regEl = el
      .replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1")
      .replace("+", "+ ")
      .replace("-", "- ")
      .replace("%", "")
    return formattedTextColumn(regEl)
  }

  // if (myElementRef.current) {
  //   // Получение id элемента
  //   const id = myElementRef.current.id;
  //   console.log("ID элемента:", id);
  // }
  const [isScrolled, setIsScrolled] = useState(false);
  useMemo(() => {
      const anchorElement = document.getElementById("containerTable")
      if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: "smooth", block: "start" })
      }
  },[isScrolled]);

  return (
    <>
      <div className={styles.headerContainer} />

      <section className={styles.section}>
        <div className={styles.navigationBox}>
          <NavLink to={"/"} className={styles.link}>
            <div className={styles.arrow}></div>
            Главная
          </NavLink>

          <NavLink to={"/tables"} className={styles.link}>
            <div className={styles.arrow}></div>
            Портфели
          </NavLink>
        </div>
      </section>

      {isLoading || table.length === 0 ? (
        <div className={styles.preloader}>
          <Preloader />
        </div>
      ) : (
        <div className={styles.main} id={"sectionTable"}>
          <h3 className={styles.mainTitle}>{table[0].name}</h3>

          <div className={styles.buttonWrapper}>
            <button
              id={"leftButton"}
              onClick={() => {
                scrollTable("left")
                setIsScrolled(false)
              }}
              className={styles.leftButtonNoActive}
            />
            <button
              id={"rightButton"}
              onClick={() => {
                scrollTable("right")
                setIsScrolled(false)
              }}
              className={styles.rightButton}
            />
          </div>

          <div className={styles.tableWrapper} id={"tableWrapper"}>
          {promptToggle === null && (
            <TablePrompt setPromptToggle={setPromptToggle} />
          )}
            <div
              className={styles.table}
              id={"containerTable"}
              onScroll={() => {
                // setIsScrolled(prev => !prev)
                scrollTable()
              }}
              onMouseOver={() => {setIsScrolled(true)}}
              
            >
            
              <table className={styles.container} onClick={() => {setIsScrolled(prev => !prev)}} id={"container"}>
              
                <thead>
                  <tr className={styles.titleBox} id={"titleBox"}>
                    {table.map((element, index) => {
                      if (table.length > 3 ? index === 3 : index === 1) {
                        return sortKeys(Object.keys(element)).map(
                          (keyName, i) => (
                            <th
                              ref={ref}
                              className={styles.columnHeadline}
                              key={i}
                            >
                              <span className={headlineStyles(keyName, i)}>
                                {formattedTextTitle(keyName)}
                              </span>
                            </th>
                          )
                        )
                      }
                      return null
                    })}
                  </tr>
                </thead>

                <tbody>
                  <img
                    src={cursorPrompt}
                    id={"cursorPrompt"}
                    style={{
                      opacity: `${promptVisible}`,
                      // "transform": "115s",
                      transition: "0.2s",
                      position: "absolute",
                      top: `${cursorPosition.y - 320}px`, // Небольшое смещение от курсора по вертикали
                      left: `${cursorPosition.x - 310}px`, // Небольшое смещение от курсора по горизонтали
                      zIndex: "9999", // Поместите изображение над другими элементами
                    }}
                  />
                  {table.map((element, index, array) => {
                    if (index !== 0) {
                      return (
                        <tr key={index} className={styles.evenRow}>
                          {Object.keys(element).map((keyName, i, arr) => (
                            <td
                              key={keyName}
                              onMouseLeave={() => {
                                setPromptVisible("0")
                              }}
                              onMouseEnter={() => {
                                handleMouseMove(keyName, i, index, element)
                              }}
                              className={leftLineStyle(
                                keyName,
                                i,
                                index,
                                element
                              )}
                            >
                              <div className={styles.column} key={i}>
                                <span
                                  className={txtColor(
                                    keyName,
                                    element[keyName],
                                    i
                                  )}
                                >
                                  {arrow(keyName, i, element)}

                                  {formattedText(element[keyName])}
                                </span>
                              </div>
                            </td>
                          ))}
                        </tr>
                      )
                    }
                    return null
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Table
